import Slideshow, {SlideshowChangeEvent} from '~/app/elements/Slideshow';
import addSwipeEventListeners from '~/app/utils/addSwipeEventListeners';
import scrollElementTo from '~/utils/animation/scrollElementTo';
import scroll from '~/app/Common/Scroll/index';

/**
 * Класс обратного направления листания.
 */
const CLASS_BACKWARDS = 'backwards';
/**
 * Скрипты слайдшоу завершили инициализацию.
 */
const CLASS_READY = 'ready';

/**
 * Слайдшоу.
 */
function main(): void
{
	scroll();
	
	const container = document.querySelector(
		'main>div.projects',
	) as HTMLElement;
	const projectLinks = document.querySelectorAll(
		'main>div.content>div.projects>ul>li>a',
	) as NodeListOf<HTMLAnchorElement>;
	
	if ( container )
	{
		init( container, projectLinks );
	}
}

/**
 * Инициализация элемента слайдшоу.
 * 
 * @param container Контейнер слайдшоу.
 * @param links Ссылки на слайды.
 */
function init( container: HTMLElement, links: NodeListOf<HTMLAnchorElement> ): void
{
	const slidesList = container.querySelector( 'div.slides' ) as HTMLElement;
	const controls = container.querySelector( 'div.controls' ) as HTMLElement;
	const btnPrev = controls.querySelector( 'button.prev' ) as HTMLElement;
	const btnNext = controls.querySelector( 'button.next' ) as HTMLElement;
	const currentSlide = controls.querySelector( 'span.counter>span.current' ) as HTMLElement;
	const slidesCount = controls.querySelector( 'span.counter>span.total' ) as HTMLElement;
	
	const slideshow = new Slideshow( slidesList );
	
	let changedByButton: boolean = false;
	
	slidesList.addEventListener(
		Slideshow.EVENT_CHANGE,
		( event: SlideshowChangeEvent ) =>
		{
			// При автоматическом листании направление всегда «вперёд».
			if ( !changedByButton )
			{
				slidesList.classList.remove( CLASS_BACKWARDS );
			}
			
			changedByButton = false;
			
			currentSlide.textContent = String( event.detail.currentSlide + 1 );
			slidesCount.textContent = String( event.detail.slidesCount );
		},
	);
	
	const toNext = (): void =>
	{
		changedByButton = true;
		slidesList.classList.remove( CLASS_BACKWARDS );
		slideshow.next();
	};
	
	const toPrev = (): void =>
	{
		changedByButton = true;
		slidesList.classList.add( CLASS_BACKWARDS );
		slideshow.prev();
	};
	
	btnPrev.addEventListener( 'click', toPrev );
	btnNext.addEventListener( 'click', toNext );
	
	slideshow.toSlide( 0 );
	// slideshow.autoSlideshow( 7000 );
	
	addSwipeEventListeners(
		slidesList,
		{
			right: toPrev,
			left: toNext,
		},
	);
	
	const slidesIndexById = new Map<string, number>();
	const slides = slidesList.children;
	
	for ( let i = 0, n = slides.length; i < n; i++ )
	{
		if ( slides[i].id )
		{
			slidesIndexById.set( slides[i].id, i );
		}
	}
	
	const onLinkClick = ( event: MouseEvent ): void =>
	{
		const target = event.currentTarget as HTMLAnchorElement;
		const href = (target.getAttribute( 'href' ) || '').substr( 1 );
		
		if ( href && slidesIndexById.has( href ) )
		{
			// tslint:disable-next-line:no-non-null-assertion
			slideshow.toSlide( slidesIndexById.get( href )! );
			
			const top = container.getBoundingClientRect().top;
			
			if ( top > 10 )
			{
				scrollElementTo( window, window.pageYOffset + top, Math.abs( top ) );
			}
			
			event.preventDefault();
		}
	};
	
	for ( let i = 0, n = links.length; i < n; i++ )
	{
		links[i].addEventListener( 'click', onLinkClick );
	}
	
	container.classList.add( CLASS_READY );
}

/**
 * Module.
 */
export {
	main as default,
};



// WEBPACK FOOTER //
// ./app/Routes/Company/index.ts